<template>
  <div class="dem-edi-rod">
    <div class="item-titulo">
      <i aria-hidden="true" class="fa fa-angle-double-right"></i>
      Dados Adicionais
    </div>

    <div class="item-conteudo">
      <!-- SETA O STATUS DE CARREGANDO DA PAGINA -->
      <RF-Status v-if="statusGeral !== ''" :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>

      <!-- SETA OS DADOS DA TELA -->
      <template v-else>
        <table>
          <tr>  
            <td class="dem-edi-rod-dem_obs">
              <div>
                <template v-if="[ 'dev_cliente', 'dev_fornecedor', 'compra' ].indexOf(cpntDemanda) === -1">
                  <App-Calendario :data-time="time" class="app-cpnt-field dem-rod--dem_data_ent"
                    :cpntStatus='campos.dem_data_ent.status'
                    :cpntId='campos.dem_data_ent.id'
                    :cpntTabIndex='campos.dem_data_ent.tabIndex'
                    :cpntClassDivField='campos.dem_data_ent.classDivField'
                    :cpntNome='campos.dem_data_ent.nome'
                    :cpntValue='campos.dem_data_ent.value'
                    :cpntAutoComplete='campos.dem_data_ent.autocomplete'
                    :cpntMask='campos.dem_data_ent.mask'
                    :cpntDisabled='campos.dem_data_ent.disabled'
                    :cpntMostrar='campos.dem_data_ent.mostrar'
                    :cpntAutoFocus='campos.dem_data_ent.autofocus'
                    :cpntMensagem='campos.dem_data_ent.mensagem'
                    :cpntMensagemTipo='campos.dem_data_ent.mensagemTipo'
                    :cpntPlaceholder='campos.dem_data_ent.placeholder'
                    :cpntPosicionar='campos.dem_data_ent.posicionar'
                    :cpntOnChange='campos.dem_data_ent.onChange'
                    ref='dem_data_ent'
                  ></App-Calendario>

                  <App-Input :data-time="time" class="app-cpnt-field dem-rod--id_vei_km"
                    :cpntStatus='campos.id_vei_km.status'
                    :cpntId='campos.id_vei_km.id'
                    :cpntTabIndex='campos.id_vei_km.tabIndex'
                    :cpntClassDivField='campos.id_vei_km.classDivField'
                    :cpntNome='campos.id_vei_km.nome'
                    :cpntValue='campos.id_vei_km.value'
                    :cpntAutoComplete='campos.id_vei_km.autocomplete'
                    :cpntMask='campos.id_vei_km.mask'
                    :cpntDisabled='campos.id_vei_km.disabled'
                    :cpntMostrar='campos.id_vei_km.mostrar'
                    :cpntAutoFocus='campos.id_vei_km.autofocus'
                    :cpntMensagem='campos.id_vei_km.mensagem'
                    :cpntMensagemTipo='campos.id_vei_km.mensagemTipo'
                    :cpntPlaceholder='campos.id_vei_km.placeholder'
                    :cpntPosicionar='campos.id_vei_km.posicionar'
                    :cpntOnChange='campos.id_vei_km.onChange'
                    :cpntOnBlur='campos.id_vei_km.onBlur'
                    ref='id_vei_km'
                  ></App-Input>

                  <div class="separador">&nbsp;</div>
                </template>

                <App-Ckeditor :data-time="time" class="app-cpnt-field dem-rod--dem_obs"
                  :cpntStatus='campos.dem_obs.status'
                  :cpntId='campos.dem_obs.id'
                  :cpntClassDivField='campos.dem_obs.classDivField'
                  :cpntNome='campos.dem_obs.nome'
                  :cpntValue='campos.dem_obs.value'
                  :cpntAutoComplete='campos.dem_obs.autocomplete'
                  :cpntDisabled='campos.dem_obs.disabled'
                  :cpntMostrar='campos.dem_obs.mostrar'
                  :cpntMensagem='campos.dem_obs.mensagem'
                  :cpntMensagemTipo='campos.dem_obs.mensagemTipo'
                  :cpntConfig='campos.dem_obs.config'
                  :cpntExplica='campos.dem_obs.explica'
                  :cpntTabIndex='campos.dem_obs.tabIndex'

                  :cpntOnChange='campos.dem_obs.onChange'
                  :cpntOnBlur='campos.dem_obs.onBlur'
                  ref='dem_obs'
                ></App-Ckeditor>
              </div>
            </td>

            <td class="dem-edi-rod-dem_nf" v-if="[ 'dev_cliente', 'dev_fornecedor' ].indexOf(cpntDemanda) === -1 && acesso.pacoteNF === true">
              <div>
                <App-Toggles :data-time="time" class="app-cpnt-field dem-rod--dem_obs_nf_separado"
                  :cpntStatus='campos.dem_obs_nf_separado.status'
                  :cpntId='campos.dem_obs_nf_separado.id'
                  :cpntClassDivField='campos.dem_obs_nf_separado.classDivField'
                  :cpntNome='campos.dem_obs_nf_separado.nome'
                  :cpntValue='campos.dem_obs_nf_separado.value'
                  :cpntDisabled='campos.dem_obs_nf_separado.disabled'
                  :cpntMostrar='campos.dem_obs_nf_separado.mostrar'
                  :cpntMensagem='campos.dem_obs_nf_separado.mensagem'
                  :cpntMensagemTipo='campos.dem_obs_nf_separado.mensagemTipo'
                  :cpntOn='campos.dem_obs_nf_separado.on'
                  :cpntOff='campos.dem_obs_nf_separado.off'
                  :cpntExplica='campos.dem_obs_nf_separado.explica'
                  :cpntWidth='campos.dem_obs_nf_separado.width'
                  :cpntTabIndex='campos.dem_obs_nf_separado.tabIndex'

                  :cpntOnChange='campos.dem_obs_nf_separado.onChange'
                  :cpntOnBlur='campos.dem_obs_nf_separado.onBlur'
                  ref='dem_obs_nf_separado'
                ></App-Toggles>

                <div class="separador">&nbsp;</div>

                <App-Ckeditor :data-time="time" class="app-cpnt-field dem-rod--dem_obs_nf"
                  :cpntStatus='campos.dem_obs_nf.status'
                  :cpntId='campos.dem_obs_nf.id'
                  :cpntClassDivField='campos.dem_obs_nf.classDivField'
                  :cpntNome='campos.dem_obs_nf.nome'
                  :cpntValue='campos.dem_obs_nf.value'
                  :cpntAutoComplete='campos.dem_obs_nf.autocomplete'
                  :cpntDisabled='campos.dem_obs_nf.disabled'
                  :cpntMostrar='campos.dem_obs_nf.mostrar'
                  :cpntMensagem='campos.dem_obs_nf.mensagem'
                  :cpntMensagemTipo='campos.dem_obs_nf.mensagemTipo'
                  :cpntConfig='campos.dem_obs_nf.config'
                  :cpntExplica='campos.dem_obs_nf.explica'
                  :cpntTabIndex='campos.dem_obs_nf.tabIndex'

                  :cpntOnChange='campos.dem_obs_nf.onChange'
                  :cpntOnBlur='campos.dem_obs_nf.onBlur'
                  ref='dem_obs_nf'
                ></App-Ckeditor>
              </div>
            </td>

            <td class="dem-edi-rod-dem_obs_emp">
              <div>
                <App-Ckeditor :data-time="time" class="app-cpnt-field dem-rod--dem_obs_emp"
                  :cpntStatus='campos.dem_obs_emp.status'
                  :cpntId='campos.dem_obs_emp.id'
                  :cpntClassDivField='campos.dem_obs_emp.classDivField'
                  :cpntNome='campos.dem_obs_emp.nome'
                  :cpntValue='campos.dem_obs_emp.value'
                  :cpntAutoComplete='campos.dem_obs_emp.autocomplete'
                  :cpntDisabled='campos.dem_obs_emp.disabled'
                  :cpntMensagem='campos.dem_obs_emp.mensagem'
                  :cpntMensagemTipo='campos.dem_obs_emp.mensagemTipo'
                  :cpntConfig='campos.dem_obs_emp.config'
                  :cpntExplica='campos.dem_obs_emp.explica'
                  :cpntTabIndex='campos.dem_obs_emp.tabIndex'
                  :cpntMostrar="campos.dem_obs_emp.mostrar"

                  :cpntOnChange='campos.dem_obs_emp.onChange'
                  :cpntOnBlur='campos.dem_obs_emp.onBlur'
                  ref='dem_obs_emp'
                ></App-Ckeditor>
              </div>
            </td>
          </tr>
        </table>
      </template>
    </div>
  </div>
</template>

<style scoped>
.dem-edi-rod {
  margin-top: 10px;
}
  .dem-edi-rod > .item-conteudo {
    width: 100%;
    border-radius: 5px;
    margin: 0px 0px 0px 0px;
    padding: 5px 5px 5px 5px;
    min-height: 150px;
    text-decoration: none;
    border: 1px solid #c6c4c4;
  }
    .dem-edi-rod > .item-conteudo > .rf-status {
      line-height: 140px;
    }

    .dem-edi-rod > .item-conteudo > table {
      width: 100%;
    }
      .dem-edi-rod > .item-conteudo > table > tr > td {
        padding-top: 18px;
        vertical-align: top;
      }

      .dem-edi-rod > .item-conteudo > table > tr > td.dem-edi-rod-dem_obs,
      .dem-edi-rod > .item-conteudo > table > tr > td.dem-edi-rod-dem_obs_emp {
        vertical-align: bottom;
      }
      .dem-edi-rod > .item-conteudo > table > tr > td > div {
        width: 330px;
        margin: 0px auto;
      }
        .dem-edi-rod > .item-conteudo > table > tr > td > div > .rf-input-group {
          margin-bottom: 5px;
        }
        .dem-edi-rod > .item-conteudo > table > tr > td > div > .rf-input-group ~ .rf-input-group {
          margin-left: 10px;
        }
        .dem-edi-rod > .item-conteudo > table > tr > td > div > .dem-rod--dem_data_ent,
        .dem-edi-rod > .item-conteudo > table > tr > td > div > .dem-rod--id_vei_km {
          width: calc((100% / 2) - 5px);
          margin-top: 15px;
        }
        .dem-edi-rod > .item-conteudo > table > tr > td > div > .dem-rod--id_vei_km {
          margin-left: 10px;
        }
        .dem-edi-rod > .item-conteudo > table > tr > td > div > .separador {
          width: 100%;
          display: block;
          clear: both;
        }
        .dem-edi-rod > .item-conteudo > table > tr > td > div > .dem-rod--dem_obs,
        .dem-edi-rod > .item-conteudo > table > tr > td > div > .dem-rod--dem_obs_nf {
          width: 100%;
          margin-left: 0px !important;
          margin-bottom: 5px !important;
        }
        .dem-edi-rod > .item-conteudo > table > tr > td > div > .dem-rod--dem_obs_nf_separado {
          margin-top: 15px;
          width: 100%;
        }
</style>

<style>
  .dem-edi-rod > .item-conteudo > table > tr > td > div > .dem-rod--dem_obs_nf_separado > .toggle {
    max-width: 170px !important;
  }
</style>

<script>
  export default {
    props: {
      cpntDemanda: {
        required: true
      },
      cpntDemandaId: {
        required: true
      },

      cpntDataEntrega: {
        required: true
      },
      cpntIdVei: {
        required: true
      },
      cpntIdVeiKM: {
        required: true
      },
      cpntObservacao: {
        required: true
      },
      cpntObservacaoNfSeparado: {
        required: true
      },
      cpntObservacaoNF: {
        required: true
      },
      cpntObservacaoEmp: {
        required: true
      }
    },
    components: {
      // 'App-Input': () => import('@/components/rf-geral/input/RF-Input.vue'),
      'App-Ckeditor': () => import('@/components/rf-geral/ckeditor/RF-Ckeditor.vue'),
      // 'App-Toggles': () => import('@/components/rf-geral/toggles/RF-Toggles.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        campos: {
          dem_data_ent: {
            id: 'dem-edi-cab--dem_data_ent',
            status: '',
            tabIndex: 17040001,
            nome: 'Data Entrega',
            apiRec: 'cpntDataEntrega',
            apiEnv: 'dt_ent',
            value: '',
            onChange: this.demEditarRodOnChange,
            onBlur: this.demEditarRodOnBlur
          },
          id_vei_km: {
            id: 'dem-edi-cab--id_vei_km',
            status: '',
            tabIndex: 17040002,
            nome: 'KM',
            apiRec: 'cpntIdVeiKM',
            apiEnv: 'km',
            value: '',
            onChange: this.demEditarRodOnChange,
            onBlur: this.demEditarRodOnBlur
          },
          dem_obs: {
            id: 'dem-edi-cab--dem_obs',
            status: '',
            tabIndex: 17040003,
            nome: 'Obs.',
            config: {
              toolbar: [
                [ 'Maximize' ],
                [ '-', 'Bold', 'Italic', 'Underline', 'Strike', 'RemoveFormat' ],
                [ 'Image', 'Link', 'Unlink' ],
                [ 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock' ],
                [ 'Font', 'FontSize' ],
                [ 'TextColor', 'BGColor' ]
              ],
              toolbarCanCollapse: true,
              toolbarStartupExpanded: false,
              height: '80'
            },
            explica: null,
            apiRec: 'cpntObservacao',
            apiEnv: 'obs_cli',
            value: '',
            onChange: this.demEditarRodOnChange,
            onBlur: this.demEditarRodOnBlur
          },

          dem_obs_nf_separado: {
            id: 'dem-edi-cab--dem_obs_nf_separado',
            status: '',
            tabIndex: 17040004,
            tipo: 'toggles',
            nome: 'Para <u>Nota Fiscal</u> utilizar a seguinte observação: ',
            on: 'Obs. Nota Fiscal',
            off: (this.cpntDemanda === 'compra' ? 'Obs. Fornecedor' : 'Obs. Cliente'),
            apiRec: 'cpntObservacaoNfSeparado',
            apiEnv: 'obs_nf_pro_separado',
            value: '',
            onChange: this.demEditarRodOnChange,
            onBlur: this.demEditarRodOnBlur
          },
          dem_obs_nf: {
            id: 'dem-edi-cab--dem_obs_nf',
            status: '',
            tabIndex: 17040005,
            nome: 'Obs. Nota Fiscal',
            config: {
              toolbar: [
                [ 'Maximize' ],
                [ '-', 'Bold', 'Italic', 'Underline', 'Strike', 'RemoveFormat' ],
                [ 'Image', 'Link', 'Unlink' ],
                [ 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock' ],
                [ 'Font', 'FontSize' ],
                [ 'TextColor', 'BGColor' ]
              ],
              toolbarCanCollapse: true,
              toolbarStartupExpanded: false,
              height: '80'
            },
            apiRec: 'cpntObservacaoNF',
            apiEnv: 'obs_nf_pro',
            value: '',
            onChange: this.demEditarRodOnChange,
            onBlur: this.demEditarRodOnBlur
          },

          dem_obs_emp: {
            id: 'dem-edi-cab--dem_obs_emp',
            status: '',
            tabIndex: 17040006,
            nome: 'Obs. Empresa',
            config: {
              toolbar: [
                [ 'Maximize' ],
                [ '-', 'Bold', 'Italic', 'Underline', 'Strike', 'RemoveFormat' ],
                [ 'Image', 'Link', 'Unlink' ],
                [ 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock' ],
                [ 'Font', 'FontSize' ],
                [ 'TextColor', 'BGColor' ]
              ],
              toolbarCanCollapse: true,
              toolbarStartupExpanded: false,
              height: '80'
            },
            explica: null,
            apiRec: 'cpntObservacaoEmp',
            apiEnv: 'obs_emp',
            value: '',
            onChange: this.demEditarRodOnChange,
            onBlur: this.demEditarRodOnBlur
          }
        },
        acesso: {
          pacoteNF: false
        }
      }
    },
    mounted: function () {
      this.demEditarRodIniciar()
    },
    methods: {
      demEditarRodIniciar: function () {
        // SETA O STATUS DA TELA
        this.demEditarRodSetarStatusGeral('carregando')

        // VERIFICA SE TEM ALGUM PACOTE DE NOTA FISCAL
        this.acesso.pacoteNF = this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 20, 23, 25 ], 'or', null, null, null, null, false) === true

        // PEGA O NOME DE CADA CHAVE QUE DEVE SETAR O VALOR
        var chaves = Object.keys(this.campos)

        // RODA O VETOR DOS CAMPOS
        for (var indexC in chaves) {
          // SETA O NOME DA CHAVE QUE SERÁ TRABALHADA
          var chave = chaves[indexC]

          // SETA OS VALORES DO CAMPO
          this.demEditarRodSetarValorCampo(chave)

          // SETA O VALOR INICIAL DO CAMPO
          this.campos[chave].valueIni = this.campos[chave].value
        }

        // SETA O STATUS DA TELA
        this.demEditarRodSetarStatusGeral('')
      },
      demEditarRodSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demEditarRodSetarValorCampo: function (chave) {
        // INICIA A VARIAVEL DE VALOR
        var value = ''
        var valueRef = ''
        var options = []
        var mostrar = false

        // VERIFICA O VALOR QUE DEVE SELECIONAR
        switch (chave) {
          case 'dem_data_ent':
            // SETA O VALOR DO CAMPO
            value = this.cpntDataEntrega
            
            // VERIFICA SE O CAMPO DEVE SER MOSTRADO
            this.campos.dem_data_ent.mostrar = (this.cpntDemanda === 'venda'&& this.$store.state.configuracoes.venda.ven.cfg_dt_ent === true)
            break

          case 'id_vei_km':
            // SETA O VALOR DO CAMPO
            value = this.cpntIdVeiKM

            // VERIFICA SE O CAMPO DEVE SER MOSTRADO
            this.campos.id_vei_km.mostrar = (this.cpntDemanda === 'venda' && [ '', null, undefined ].indexOf(this.cpntIdVei) === -1 && this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 8 ], null, null, null, null, null, false) === true)
            break

          case 'dem_obs':
            // SETA O VALOR DO CAMPO
            value = this.cpntObservacao

            // VERIFICA A OPÇÃO QUE DEVE ADICIONAR NO CAMPO
            switch (this.cpntDemanda) {
              case 'venda':
                this.$set(this.campos[chave], 'nome', 'Obs. Cliente')
                break

              case 'compra':
                this.$set(this.campos[chave], 'nome', 'Obs. Fornecedor')
                break

              case 'dev_cliente':
              case 'dev_fornecedor':
                this.$set(this.campos[chave], 'nome', 'Obs. Nota Fiscal')
                break
            }
            
            // VERIFICA SE DEVE MOSTRAR O CAMPO
            switch (this.cpntDemanda) {
              case 'venda':
                mostrar = this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 17 ], null, [ 10 ], null, [ 41 ], null, false) === true
                break

              case 'compra':
                mostrar = this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 5 ], null, [ 11 ], null, [ 46 ], null, false) === true
                break

              case 'dev_fornecedor':
                mostrar = this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 5 ], null, [ 60 ], null, [ 911 ], null, false) === true
                break

              case 'dev_cliente':
                mostrar = this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 17 ], null, [ 59 ], null, [ 904 ], null, false) === true
                break
            }

            // VERIFICA SE TEM QUE MOSTRAR O CAMPO OU NÃO
            this.campos.dem_obs.mostrar = mostrar
            break

          case 'dem_obs_nf_separado':
            // SETA O VALOR DO CAMPO
            value = [ true, 's', 'true' ].indexOf(this.cpntObservacaoNfSeparado) !== -1

            // SETA O VALOR DA EXPLICAÇÃO DO CAMPO
            this.campos.dem_obs.explica = (value === false ? { mensagem: 'Ao emitir um nota fiscal este campo será adicionado automaticamente em <u>dados adicionais</u> da nota fiscal.' } : null)

            // VERIFICA SE DEVE MOSTRAR OU NÃO O CAMPO
            mostrar = value === true

            // VERIFICA SE DEVE MOSTRAR O CAMPO
            if (mostrar === true) {
              switch (this.cpntDemanda) {
                case 'venda':
                  mostrar = this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 17 ], null, [ 10 ], null, [ 41 ], null, false) === true
                  break

                case 'compra':
                  mostrar = this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 5 ], null, [ 11 ], null, [ 46 ], null, false) === true
                  break

                case 'dev_fornecedor':
                  mostrar = this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 5 ], null, [ 60 ], null, [ 911 ], null, false) === true
                  break

                case 'dev_cliente':
                  mostrar = this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 17 ], null, [ 59 ], null, [ 904 ], null, false) === true
                  break
              }
            }

            // VERIFICA SE TEM QUE MOSTRAR O CAMPO
            this.campos.dem_obs_nf.mostrar = mostrar
            break

          case 'dem_obs_nf':
            value = this.cpntObservacaoNF

            // VERIFICA SE DEVE MOSTRAR O CAMPO
            switch (this.cpntDemanda) {
              case 'venda':
                mostrar = (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 20, 23, 25 ], 'or', [ 38, 46, 48 ], 'or', [ 318, 323, 518 ], 'or', false) === true && this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 17 ], null, [ 10 ], null, null, null, false) === true)
                break

              case 'compra':
                mostrar = (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 20, 23, 25 ], 'or', [ 38, 46, 48 ], 'or', [ 318, 323, 518 ], 'or', false) === true && this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 5 ], null, [ 11 ], null, null, null, false) === true)
                break

              case 'dev_fornecedor':
                mostrar = this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 5 ], null, [ 60 ], null, [ 911 ], null, false) === true
                break

              case 'dev_cliente':
                mostrar = this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 17 ], null, [ 59 ], null, [ 904 ], null, false) === true
                break
            }

            // VERIFICA SE TEM QUE MOSTRAR O CAMPO OU NÃO
            this.campos.dem_obs_nf.mostrar = this.campos.dem_obs_nf_separado.value === true && mostrar
            break

          case 'dem_obs_emp':
            // SETA O VALOR DO CAMPO
            value = this.cpntObservacaoEmp

            // VERIFICA SE DEVE MOSTRAR O CAMPO
            switch (this.cpntDemanda) {
              case 'venda':
                mostrar = this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 17 ], null, [ 10 ], null, [ 42 ], null, false) === true
                break

              case 'compra':
                mostrar = this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 5 ], null, [ 11 ], null, [ 47 ], null, false) === true
                break

              case 'dev_fornecedor':
                mostrar = this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 5 ], null, [ 60 ], null, [ 911 ], null, false) === true
                break

              case 'dev_cliente':
                mostrar = this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 17 ], null, [ 59 ], null, [ 904 ], null, false) === true
                break
            }

            // VERIFICA SE TEM QUE MOSTRAR O CAMPO OU NÃO
            this.campos.dem_obs_emp.mostrar = mostrar

            // SETA O VALOR DA EXPLICAÇÃO DO CAMPO
            this.campos.dem_obs_emp.explica = (this.acesso.pacoteNF === true ? { mensagem: 'Este campo <b>não</b> é incluido na nota fiscal. Apenas pra informação interna da empresa.', posicaoMy: 'top right', posicaoAt: 'bottom left' } : null)
            break
        }

        // VERIFICA SE TEM OPTION E O VALOR SELECIONADO É UM STRING
        if (options.length >= 1 && typeof value === 'string') {
          // PEGA O VALOR DO CAMPO
          var valor = options.filter((option) => { return option[this.campos[chave].keyValue] === value })

          // SETA O VALOR ENCONTRADO
          value = valor.length === 1 ? valor[0] : value
        }

        // SETA O VALOR ATUALIZADO DO CAMPO
        this.$set(this.campos[chave], 'value', value)
        this.$set(this.campos[chave], 'options', options)
        this.$set(this.campos[chave], 'valueRef', valueRef)

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demEditarRodOnChange: function (value, id) {
        // PEGA O NOME DO CAMPO QUE ESTÁ SENDO ALTERADO
        var indexF = id.split('--')

        // VERIFICA A AÇÃO QUE DEVE REALIZAR NO CAMPO
        if ([ '' ].indexOf(indexF[1]) === -1) {
          // SETA O VALOR RECEBIDO
          this.$set(this.campos[indexF[1]], 'value', value)
  
          // LIMPA O CAMPO DE MENSAGEM DE ERRO
          this.$set(this.campos[indexF[1]], 'mensagem', '')
  
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        }

        // VERIFICA A AÇÃO DO CAMPO
        switch (indexF[1]) {
          case 'dem_obs_nf_separado':
          case 'dem_data_ent':
            this.demEditarRodAtualizarCampo(indexF[1])
            break
        }
      },
      demEditarRodOnBlur: function (id) {
        // PEGA O NOME DO CAMPO QUE ESTÁ SENDO ALTERADO
        var indexF = id.split('--')[1]
        
        // VERIFICA O CAMPO QUE ESTÁ SENDO ALTERADO
        switch (indexF) {
          case 'dem_data_ent':
          case 'id_vei_km':
          case 'dem_obs':
          case 'dem_obs_nf':
          case 'dem_obs_emp':
            this.demEditarRodAtualizarCampo(indexF)
            break
        }
      },
      demEditarRodAtualizarCampo: function (indexF = '') {
        // REMOVE O FOCUS DE QUALQUER CAMPO
        if (document.activeElement !== document.body) {
          document.activeElement.blur()
        }

        // VERIFICA SE TEM ALTERAÇÃO NO CAMPO
        if (this.campos[indexF].value !== this.campos[indexF].valueIni) {
          // TRAVA A TELA
          this.$emit('DEMANDA_TRAVAR_TELA', true)

          // IMPORA A FUNÇÃO CALCULA A FOR DA LETRA
          const FUN_PEGAR_CHAVE_DEMANDA = require('@/assets/js/Funcoes-Gerais.js').FUN_PEGAR_CHAVE_DEMANDA

          // PEGA A CHAVE REFERENCIA
          var chaveD = FUN_PEGAR_CHAVE_DEMANDA(this.cpntDemanda)

          // INICIA A VARIAVEL PARA RECEBER A ROTA
          var router = ''

          // INICIA O FORMULARIO
          var formData = {}

          // SETA O ID QUE DEVE ATUALIZAR
          formData[chaveD] = this.cpntDemandaId
    
          // SETA O REGISTRO DO CAMPO
          switch (this.cpntDemanda + '--' + indexF) {
            case 'venda--dem_data_ent':
              // router = '/demanda/dem-venda/dem-data-ent'
              formData[this.campos[indexF].apiEnv] = this.campos[indexF].value
              break
            case 'compra--dem_data_ent':
              // router = '/demanda/dem-compra/dem-data-ent'
              formData[this.campos[indexF].apiEnv] = this.campos[indexF].value
              break
  
            case 'venda--dem_obs':
              // router = '/demanda/dem-venda/dem-obs'
              formData[this.campos[indexF].apiEnv] = this.campos[indexF].value
              break
            case 'compra--dem_obs':
              router = '/demanda/dem-compra/dem-obs'
              formData.dem_obs = this.campos[indexF].value
              break
            case 'dev_cliente--dem_obs':
              router = '/demanda/dem-dev-cliente/dem-obs'
              formData.dem_obs = this.campos[indexF].value
              break
            case 'dev_fornecedor--dem_obs':
              router = '/demanda/dem-dev-fornecedor/dem-obs'
              formData.dem_obs = this.campos[indexF].value
              break
  
            case 'venda--dem_obs_nf_separado':
              // router = '/demanda/dem-venda/dem-obs-nf-separado'
              formData[this.campos[indexF].apiEnv] = [ true, 's', 'true' ].indexOf(this.campos[indexF].value) !== -1 ? 's' : 'n'
              break
            case 'compra--dem_obs_nf_separado':
              router = '/demanda/dem-compra/dem-obs-nf-separado'
              formData.dem_obs_nf_separado = [ true, 's', 'true' ].indexOf(this.campos[indexF].value) !== -1 ? 's' : 'n'
              break
  
            case 'venda--dem_obs_nf':
              // router = '/demanda/dem-venda/dem-obs-nf'
              formData[this.campos[indexF].apiEnv] = this.campos[indexF].value
              break
            case 'compra--dem_obs_nf':
              router = '/demanda/dem-compra/dem-obs-nf'
              formData.dem_obs_nf = this.campos[indexF].value
              break
  
            case 'venda--dem_obs_emp':
              // router = '/demanda/dem-venda/dem-obs-emp'
              formData[this.campos[indexF].apiEnv] = this.campos[indexF].value
              break
            case 'compra--dem_obs_emp':
              router = '/demanda/dem-compra/dem-obs-emp'
              formData.dem_obs_emp = this.campos[indexF].value
              break
            case 'dev_cliente--dem_obs_emp':
              router = '/demanda/dem-dev-cliente/dem-obs-emp'
              formData.dem_obs_emp = this.campos[indexF].value
              break
            case 'dev_fornecedor--dem_obs_emp':
              router = '/demanda/dem-dev-fornecedor/dem-obs-emp'
              formData.dem_obs_emp = this.campos[indexF].value
              break
  
            case 'venda--id_vei_km':
              // router = '/demanda/dem-venda/id-vei-km'
              formData[this.campos[indexF].apiEnv] = this.campos[indexF].value
              break
          }
          
          // SETA A ROTA QUE DEVE CHAMAR PARA ATUALIZAR OS DADOS
          if (router === '') {
            router = '/venda'
          } else {
            formData = { lot: [ formData ] }
          }
  
          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          this.$store.state.comunicaAPI(router, 'PUT', formData, (retorno) => {
            // PEGA O VALOR RECEBIDO
            retorno = [ '', null, undefined ].indexOf(retorno.lot) === -1 ? retorno.lot[0] : { code: '200', message: retorno.message }
  
            // VERIFICA SE DEU ERRO E RETORNA OS VALORES ORIGINAL DO CAMPO
            if (retorno.code !== '200') {
              this.demEditarRodTratarValidacao(retorno.message, retorno.code)
            } else {
              // APRESENTA A MENSAGEM DE SUCESSO
              this.$store.state.TRATAR_RET_LOT_API(retorno)
    
              // DESTRAVA A TELA
              this.$emit('DEMANDA_TRAVAR_TELA', false)
  
              // ATUALIZA OS DADOS E DESTRAVA A TELA
              this.$emit('DEMANDA_BUSCAR_VALORES', () => { setTimeout(() => { this.demEditarRodIniciar() }, 100) })
  
              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
            }
          }, this.demEditarRodSetarStatusGeral, this.demEditarRodTratarValidacao)
        }
      },
      demEditarRodTratarValidacao: function (apiValid, apiStatus = 400, callback = null) {
        // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
        const FUN_TRATAR_VALIDACAO_API = require('@/assets/js/Funcoes-Gerais.js').FUN_TRATAR_VALIDACAO_API

        // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
        FUN_TRATAR_VALIDACAO_API(apiValid, apiStatus, this.campos, this).then(() => {
          // DESTRAVA A TELA
          this.$emit('DEMANDA_TRAVAR_TELA', false)

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
          
          // EXECUTA O CALLBACK RECEBIDO
          if (callback !== null && typeof callback === 'function') {
            callback()
          }
        })
      },
      
    },
    watch: {
      cpntIdVei: function () {
        this.demEditarRodSetarValorCampo('id_vei_km')
      },
      cpntIdVeiKM: function () {
        this.demEditarRodSetarValorCampo('id_vei_km')
      },
      cpntDataEntrega: function () {
        this.demEditarRodSetarValorCampo('dem_data_ent')
      },
      cpntObservacao: function () {
        this.demEditarRodSetarValorCampo('dem_obs')
      },
      cpntObservacaoNfSeparado: function () {
        this.demEditarRodSetarValorCampo('dem_obs_nf_separado')
      },
      cpntObservacaoNF: function () {
        this.demEditarRodSetarValorCampo('dem_obs_nf')
      },
      cpntObservacaoEmp: function () {
        this.demEditarRodSetarValorCampo('dem_obs_emp')
      },
    }
  }
</script>
